import { Address } from '@/modules/address/models/Address';
import { Company } from '@/modules/company/models/Company';
import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { Country } from '@/modules/predefined/models/Country';

export class CompanyService extends BaseEntityModel {
  id?: number;
  companyId?: number;
  countryId?: number;
  type?: string;
  description?: string;
  email?: string;
  phoneNumber?: string;
  openingHours?: string;
  requiredInformation?: string;
  onlineClaimUrl?: string;
  inPersonClaimUrl?: string;
  company: Relationship<Company> | null;
  country: Relationship<Country> | null;
  mailingAddress: Relationship<Address> | null;

  constructor(model: Partial<CompanyService> = {}) {
    super(model);

    this.id = model.id;
    this.companyId = model.companyId;
    this.countryId = model.countryId;
    this.type = model.type;
    this.description = model.description;
    this.email = model.email;
    this.phoneNumber = model.phoneNumber;
    this.openingHours = model.openingHours;
    this.requiredInformation = model.requiredInformation;
    this.onlineClaimUrl = model.onlineClaimUrl;
    this.inPersonClaimUrl = model.inPersonClaimUrl;

    this.company = Company.mapModelOrNull(model.company);
    this.country = Country.mapModelOrNull(model.country);
    this.mailingAddress = Address.mapModelOrNull(model.mailingAddress);
  }
}
